import { motion } from 'motion/react';
import styles from './Title.module.css';

export const Title = ({ line, startDelay = 0, textFontSize }) => {
  if (!line) {
    return null;
  }

  const letters = line
    ?.trim()
    ?.split('')
    ?.map((char) => (char === ' ' ? '\u00A0' : char));

  const initialIdx = Math.floor(letters.length / 2);
  const oneLetterWidth = 8;

  return (
    <div
      className={styles.firstLine}
      // dir="rtl"
      style={{ fontSize: `${textFontSize}rem` }}
    >
      {letters &&
        Array.isArray(letters) &&
        letters.map((l, idx, arr) => {
          let initialX = `${(initialIdx - idx) * oneLetterWidth}rem`;

          return (
            <motion.div
              className={styles.letter}
              style={{ position: 'relative', zIndex: idx * -1 }}
              key={l + idx}
              initial={{ scale: 0, x: initialX, opacity: 0 }}
              animate={{
                opacity: 1,
                scale: 1,
                x: 0,
                transition: {
                  duration: 0.3,
                  delay: idx * 0.02 + startDelay,
                  ease: 'easeOut',
                },
              }}
              exit={{
                opacity: 0,
              }}
            >
              {l}
            </motion.div>
          );
        })}
    </div>
  );
};
